import { createAction } from "redux-actions";
import { ACCESS_TOKEN_KEY, LOGGED_IN_SESSION_KEY, REFRESH_TOKEN_KEY } from "../../constants";
import { api } from "../../services/api";
import endPoints from "../../services/apiEndPoints";
import { LOGIN_REQUEST, LOGIN_SUCCESS, SET_CSC, SET_SETTINGS, UPDATE_USER_AUTH, SSO_LOGIN, SSO_LOGIN_SUCCESS, SSO_LOGIN_FAILURE } from "./types";
import { jwtDecode } from "jwt-decode";
const loginRequest = createAction(LOGIN_REQUEST);
const loginSuccess = createAction(LOGIN_SUCCESS);
export const setCSC = createAction(SET_CSC);
export const setSettings = createAction(SET_SETTINGS);
export const updateUserAuth = createAction(UPDATE_USER_AUTH);
export const ssoLogin = createAction(SSO_LOGIN);
export const ssoLoginSuccess = createAction(SSO_LOGIN_SUCCESS);
export const ssoLoginFailure = createAction(SSO_LOGIN_FAILURE);

export const login =
  ({ email, password, location }) =>
  async (dispatch) => {
    dispatch(loginRequest());
    return api
      .post(`${endPoints.AUTH_LOGIN}`, { email, password, location })
      .then((res) => res.data)
      .then((data) => {
        localStorage.setItem(LOGGED_IN_SESSION_KEY, true);
        localStorage.setItem(ACCESS_TOKEN_KEY, data.access);
        localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh);
        dispatch(loginSuccess({ user: data.user }));
        return data;
      })
      .catch((error) => {
        throw error;
      });
  };


export const authenticate = ({ access, refresh, data }) => async (dispatch) => {
  dispatch(loginRequest());
  sessionStorage.setItem(LOGGED_IN_SESSION_KEY, true);
  localStorage.setItem(ACCESS_TOKEN_KEY, access);
  localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
  dispatch(loginSuccess({ user: data.user }));
  return data;
};

export const exchangeSSOCode = ({code}) => async (dispatch) => {
  dispatch(ssoLogin());
  return api
    .post(`${endPoints.AUTH_SSO_EXCHANGE}`, { code })
    .then((res) => res.data)
    .then((data) => {
      dispatch(ssoLoginSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(ssoLoginFailure(error));
      throw error;
    });
};

export const ssoLogout = ({token}) => {
  if (token) {
    const tokenInfo = jwtDecode(token);

    if (tokenInfo?.auth_method === "sso") {
      const params = new URLSearchParams({
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        post_logout_redirect_uri: process.env.REACT_APP_KEYCLOAK_LOGOUT_URL,
      });

      window.location.href = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${
        process.env.REACT_APP_KEYCLOAK_REALM
      }/protocol/openid-connect/logout?${params}`;

      return;
    }
  }
};